/**
 * Array<Array<{
 *   element: Element,
 *   targetRef: AriaRef,
 *   id: string,
 *   ariaAttribute: string,
 *   callback?: (targetRef: AriaRef) => {},
 *   currentClone?: Element
 * }>>
 */
export default [];
